import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  class: "task-file-name"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = {
  key: 1
};
const _hoisted_4 = {
  key: 1,
  style: {
    "color": "red"
  }
};
const _hoisted_5 = {
  key: 2,
  style: {
    "color": "red"
  }
};
import { ref, reactive, computed, watch } from 'vue';
import { ElMessage } from 'element-plus';
import { useStore } from "vuex";
import { getFileImportResult } from './service';
export default {
  __name: 'index',
  props: {
    visible: Boolean
  },
  emits: ['update:visible', 'add'],
  setup(__props, {
    emit: __emit
  }) {
    let props = __props;
    const store = useStore();
    const emit = __emit;
    const visible = computed({
      get: () => props.visible,
      set: val => emit('update:visible', val)
    });
    const tableData = ref({});
    const timeOut = ref(undefined);
    const loading = ref(false);
    const queryInfo = reactive({
      page: 1,
      pageSize: 20
    });
    const columns = [{
      label: "文件名称",
      key: "fileName",
      // align: "center",
      width: "220",
      showOverflowTooltip: true,
      prop: "fileName",
      slot: "fileName"
    }, {
      label: "状态",
      key: "status",
      prop: "status",
      slot: "status",
      header: 'headerstatus',
      width: "200"
    }, {
      label: "导入时间",
      key: "createTime",
      width: "180",
      prop: "createTime"
    }, {
      label: "错误文件",
      key: "errorFile",
      prop: "errorFile",
      slot: "errorFile"
    }];
    const onDownload = async url => {
      try {
        let dom = document.createElement('a');
        dom.href = url;
        dom.click();
      } catch (err) {
        console.error(err);
      }
    };
    const refresh = () => {
      loading.value = true;
      loop();
    };
    const doSearch = (params = queryInfo) => {
      loading.value = true;
      fileImportResult(params);
      clearTimeout(timeOut.value);
    };
    const fileImportResult = (params = queryInfo) => {
      getFileImportResult({
        ...params
      }).then(res => {
        loading.value = false;
        tableData.value = res;
      }).finally(() => {
        loading.value = false;
      });
    };
    const onQuery = () => {
      queryInfo.page = 1;
      doSearch();
    };
    const onCurrentChange = val => {
      queryInfo.page = val;
      doSearch(queryInfo);
    };
    const taskClose = () => {
      visible.value = false;
      clearTimeout(timeOut.value);
      store.commit("home/setTaskVisible", false);
    };
    const loop = () => {
      clearTimeout(timeOut.value);
      timeOut.value = setTimeout(() => {
        fileImportResult();
        loop();
      }, 1000);
    };
    watch(() => props.visible, val => {
      if (val) {
        loop();
      }
    });
    return (_ctx, _cache) => {
      const _component_CustomTable = _resolveComponent("CustomTable");
      const _component_Close = _resolveComponent("Close");
      const _component_el_icon = _resolveComponent("el-icon");
      return _openBlock(), _createElementBlock("div", {
        class: "file-import-btt-task",
        style: _normalizeStyle({
          bottom: visible.value ? '59px' : '-400px'
        })
      }, [_createVNode(_component_CustomTable, {
        class: "file-import-btt-task-table",
        columns: columns,
        loading: loading.value,
        data: tableData.value.list,
        total: tableData.value.total,
        currentPage: queryInfo.page,
        pageSize: queryInfo.pageSize,
        layout: "prev, pager, next",
        onCurrentChange: onCurrentChange
      }, {
        fileName: _withCtx(({
          row
        }) => [_createElementVNode("div", _hoisted_1, _toDisplayString(decodeURIComponent(row.fileName)), 1)]),
        errorFile: _withCtx(({
          row
        }) => [row.errorFile ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "task-download",
          onClick: $event => onDownload(row.errorFile)
        }, " 下载 ", 8, _hoisted_2)) : (_openBlock(), _createElementBlock("div", _hoisted_3, " - "))]),
        status: _withCtx(({
          row
        }) => [row.status === 1 || row.status === 0 ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass({
            running: row.status === 0
          })
        }, _toDisplayString(row.status === 1 ? '已完成' : '进行中'), 3)) : _createCommentVNode("", true), row.status === 2 ? (_openBlock(), _createElementBlock("div", _hoisted_4, " 失败 ")) : _createCommentVNode("", true), row.status === 3 ? (_openBlock(), _createElementBlock("div", _hoisted_5, " 模板错误，请下载最新模板 ")) : _createCommentVNode("", true)]),
        headerstatus: _withCtx(({
          col
        }) => [_createElementVNode("div", {
          class: "c-refresh",
          onClick: refresh
        }, _toDisplayString(col.label), 1)]),
        _: 1
      }, 8, ["loading", "data", "total", "currentPage", "pageSize"]), _createElementVNode("div", {
        class: "file-import-task-close",
        onClick: taskClose
      }, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_component_Close)]),
        _: 1
      })])], 4);
    };
  }
};